import styled from 'styled-components';

export const Backdrop = styled.div`
  position: fixed;
  inset: 0;
  z-index: 40;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 8px;
  padding-bottom: calc(8px + env(safe-area-inset-bottom, 0px));
  background: rgba(0, 0, 0, 0.82);
`;

export const Dialog = styled.div`
  width: min(100%, 500px);
  max-height: calc(100dvh - 16px);
  overflow-y: auto;
  padding: 26px 20px 24px;
  border-radius: 14px;
  background: #f8f9fa;
  box-shadow: ${({ theme }) => theme.shadows.modalShadow};
  color: #333333;

  .dark & {
    background: #001e3b;
    box-shadow: none;
    color: #f8f9fa;
  }

  &:focus-visible {
    outline: 3px solid #5daeff;
    outline-offset: 3px;
  }

  @media screen and (max-width: 360px) {
    padding: 22px 16px 20px;
  }
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

export const Heading = styled.div`
  display: grid;
  grid-template-columns: 80px minmax(0, 1fr);
  align-items: center;
  gap: 20px;

  @media screen and (max-width: 360px) {
    grid-template-columns: 64px minmax(0, 1fr);
    gap: 14px;
  }
`;

export const Logo = styled.svg`
  display: block;
  width: 80px;
  height: 80px;
  overflow: visible;

  @media screen and (max-width: 360px) {
    width: 64px;
    height: 64px;
  }
`;

export const LogoAccent = styled.path`
  fill: #0072bc;

  .dark & {
    fill: #f8f9fa;
  }
`;

export const LogoBody = styled.path`
  fill: #000000;

  .dark & {
    fill: #f8f9fa;
  }
`;

export const Title = styled.h2`
  margin: 0;
  color: #00549a;
  font-size: clamp(1.125rem, 4.8vw, 1.5rem);
  font-weight: 700;
  line-height: 1.22;
  text-align: left;

  .dark & {
    color: #f8f9fa;
  }
`;

export const Description = styled.p`
  width: 100%;
  margin: 28px 0 0;
  color: #333333;
  font-size: clamp(1.0625rem, 4.6vw, 1.45rem);
  font-weight: 400;
  line-height: 1.28;
  text-align: left;

  .dark & {
    color: #f8f9fa;
  }
`;

export const IosHint = styled.div`
  width: 100%;
  margin-top: 20px;
  padding: 14px 16px;
  border-radius: 10px;
  background: #e5e5e5;
  color: #333333;
  font-size: 14px;
  line-height: 1.5;
  text-align: center;

  .dark & {
    background: #0f3451;
    color: #f8f9fa;
  }
`;

export const ShareSymbol = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  margin-bottom: 8px;
  border: 2px solid #00549a;
  border-radius: 7px;
  color: #00549a;
  font-size: 18px;
  font-weight: 700;

  .dark & {
    border-color: #f8f9fa;
    color: #f8f9fa;
  }

  &::before {
    content: '↑';
    transform: translateY(-2px);
  }
`;

export const Actions = styled.div`
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 28px;
  width: 100%;
  margin-top: 24px;

  &.single-action {
    grid-template-columns: minmax(0, 212px);
    justify-content: center;
  }

  @media screen and (max-width: 400px) {
    gap: 14px;
  }
`;

export const ActionButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  min-width: 0;
  height: 36px;
  padding: 0 10px;
  border: 1.5px solid #005aa4;
  border-radius: 6px;
  cursor: pointer;
  font-family: inherit;
  font-size: 0.875rem;
  font-weight: 700;
  line-height: 1;
  text-align: center;
  text-transform: uppercase;
  transition: background-color 150ms ease, color 150ms ease;

  &&[data-variant='install'] {
    background-color: #005aa4;
    color: #f8f9fa;
  }

  &&[data-variant='dismiss'] {
    background-color: #f8f9fa;
    color: #005aa4;
  }

  .dark &&[data-variant='install'] {
    border-color: #f2f2f2 !important;
    background-color: #f2f2f2 !important;
    color: #025cb7 !important;
  }

  .dark &&[data-variant='dismiss'] {
    border-color: #f8f9fa !important;
    background-color: transparent !important;
    color: #f8f9fa !important;
  }

  &:hover:not(:disabled) {
    filter: brightness(0.94);
  }

  &:focus-visible {
    outline: 3px solid #5daeff;
    outline-offset: 2px;
  }

  &:disabled {
    cursor: not-allowed;
    opacity: 0.65;
  }

  @media screen and (max-width: 360px) {
    padding: 0 6px;
    font-size: 0.75rem;
  }
`;
